/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('assets/glb-file/29.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={0.001}>
        <mesh geometry={nodes.early_skyscrapper1.geometry} material={nodes.early_skyscrapper1.material} />
      </group>
    </group>
  )
}

//useGLTF.preload('assets/glb-file/29.glb')
